module.exports = __webpack_public_path__ + "img/1565083898.46351902.jpg";